var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.description
    ? _c(
        "p",
        {
          staticClass:
            "price-page-description text-body-2 text-secondary--text",
          attrs: { itemscope: "", itemtype: "https://schema.org/Product" },
        },
        [_vm._v("\n  " + _vm._s(_setup.description) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }